export default {
    CARD: 'card',
}
